import config from "utils/appConfig";
import { getToken } from "utils/Token";

export const FEATURE_FLAGS = {
	CONTENT_FEEDS_TAB_FEATURE_FLAG: 'feature.HOPI.CONTENT_FEED_TAB',
	CONTENT_FEED_ASSIGNMENT_FLOWS: 'feature.HOPI.CONTENT_FEED_ASSIGNMENT_FLOWS',
	CONTENT_FEED_DECISIONING: "feature.HOPI.CONTENT_FEED_DECISIONING",
	NEW_PREVIEW_LINKS: 'feature.HOPI.NEW_PREVIEW_LINKS',
	AFTER_EFFECTS_SOCIAL_VERSIONS: "feature.HOPI.AFTER_EFFECTS_SOCIAL_VERSIONS",
	PREDICTIVE_SCORING: "feature.HOPI.PREDICTIVE_SCORING",
	METANODE_AUTO_OPT: 'feature.HOPI.AUTO_OPT_METANODE',
	REQUIRE_CURRENT_PASSWORD: 'feature.HOPI.REQUIRE_CURRENT_PASSWORD',
	VAST_YOUTUBE: "feature.HOPI.VAST_YOUTUBE",
	HOPI_NIVO_CHAT: "feature.HOPI.HOPI_NIVO_CHAT",
	SUPPORT_LEGACY_INNOVID_SPECIAL_CHARS: "feature.HOPI.SUPPORT_LEGACY_INNOVID_SPECIAL_CHARS",
};

const HOPI_PROJECT_ID = "prj_4059a07mli2zbrx";

export const getFeatureFlagsConfig = () => ({
	gatewayUrl: config.apiURL,
	gatewayToken: getToken(),
	projectId: HOPI_PROJECT_ID,
});
